import React from "react";
import {
    EVENT_LEAD_FORM_SUBMITTED
} from "../Support/Events";
import axios from "axios";
import {ExclamationMarkTriangle} from "../Support/Icon";
import Matomo from "../Support/Matomo";

const initialState = {
    sendingForm: false,
    showValidationHint: false
}

export default class LeadForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = initialState;
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
    }

    handleSubmit(e) {
        e.preventDefault();

        let $this = this;

        const email = e.target.querySelector('input').value;

        if (!email) {
            $this.setState({
                showValidationHint: true
            });
            return;
        }

        $this.setState({
            sendingForm: true
        }, () => {
            var formData = new FormData();
            formData.append('email', email);

            (new Matomo()).formSent();

            axios.post($this.props.apiBase + '/api/result/' + $this.props.result.scan_id + '/lead', formData, { withCredentials: true })
                .catch((error) => {
                    console.log('1st catch');
                    console.log(error.response);

                    if (error.response.status === 422) {
                        $this.setState({
                            showValidationHint: true,
                            sendingForm: false
                        });
                    }
                })
                .then((response) => {
                    if (!response) {
                        return;
                    }

                    $this.setState({
                        sendingForm: false
                    }, () => {
                        let event = new CustomEvent(EVENT_LEAD_FORM_SUBMITTED, {
                            detail: {
                                email: email
                            }
                        });

                        document.dispatchEvent(event);
                    })
                }).catch((error) => {
                console.log('2nd catch');
                console.log(error);
                //document.dispatchEvent(new CustomEvent(EVENT_LEAD_MODAL_CLOSED));
            });
        });
    }

    render() {
        return (
            <form action='#' onSubmit={this.handleSubmit}>
                <p className="mb-3">
                    Im Scan-Ergebnis listen wir für Sie die verwendeten Schriftarten mit Namen und URLs auf.
                </p>
                <p className="mb-3">
                    Damit wir Ihnen Ihr Scan-Ergebnis zusenden können, benötigen wir Ihre E-Mail-Adresse.
                </p>
                <p className="mb-3">Wir halten uns dabei an die rechtlichen Vorgaben des Double-Opt-In.</p>
                <ul>
                    <li>Geben Sie bitte Ihre korrekte E-Mail-Adresse ein.</li>
                    <li>Klicken Sie auf "Scan-Ergebnis kostenlos anfordern".</li>
                    <li>Schauen Sie in Ihr E-Mail-Postfach (SPAM-Ordner!)</li>
                </ul>
                <p>
                    Schließen Sie dieses Fenster nicht.
                    Wenn Sie Ihre E-Mail-Adresse bestätigt haben, wird Ihnen das Scan-Ergebnis angezeigt.
                </p>
                {(this.state.showValidationHint) && (
                    <div className="flex flex-row items-start mt-5 text-red-validation">
                        <ExclamationMarkTriangle className="mt-1" />
                        <span className="lead-modal--loading-text ml-2">Achtung! Bitte geben Sie eine korrekte E-Mail-Adresse ein.</span>
                    </div>
                )}
                <div className={`relative mb-2 ` + (this.state.showValidationHint ? 'mt-3' : 'mt-10')}>
                    <input type="email" id="gfs-lead-form-mail"
                           placeholder=" "/>
                    <label htmlFor="gfs-lead-form-mail"
                           className="">
                        Ihre E-Mail-Adresse
                    </label>
                </div>
                <div className="lead-modal--legal">
                    <p className="mb-2">
                        Ja, bitte senden Sie mir das Scan-Ergebnis zu.
                        Ich bin damit einverstanden, dass eRecht24 mir regelmäßig aktuelle Rechts-Updates, Praxistipps und Angebote aus den Bereichen Datenschutz, Abmahnschutz und Internetrecht per E-Mail zusendet.
                    </p>
                    <p className="mb-2"><strong>Ich kann jederzeit form- und kostenlos widersprechen.</strong></p>
                    <p>
                        Näheres entnehmen Sie unserer <a href="https://www.e-recht24.de/datenschutzerklaerung.html" target="_blank">Datenschutzerklärung</a>.
                        Wir geben Ihre Daten nicht weiter.
                    </p>
                </div>
                <button type="submit" className="button mt-8 flex flex-row items-center" disabled={this.state.sendingForm}>
                    Scan-Ergebnis kostenlos anfordern
                </button>
            </form>
        )
    }
}
